import { ServerSideQuery } from 'utils/agGrid/types';

//If the filter is false, we need to delete the filter because this specific endpoint requires
//not to send "false" for showFrequentTask if not set.
export const cleanShowFrequentTasksFilters = (
  body: ServerSideQuery,
): ServerSideQuery => {
  const filteredFilters =
    body?.filter?.filter(
      (f) => !(f.attr === 'show_frequent_tasks' && f.value === 'false'),
    ) || [];

  const { filter, ...rest } = body;
  return { ...rest, filter: filteredFilters };
};
